import script from "./DeliveryView.vue?vue&type=script&setup=true&lang=ts"
export * from "./DeliveryView.vue?vue&type=script&setup=true&lang=ts"

import "./DeliveryView.vue?vue&type=style&index=0&id=049edb81&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-049edb81"]])

export default __exports__